import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EntityTypes } from '@guryou/core';
import { getServices, StateStatus } from '@guryou/redux';

const useServicesWithoutReset = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.services.all);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getServices(EntityTypes.service));
    }
  }, [dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default useServicesWithoutReset;
